import Autoload from '../../Autoload';
import moment from 'moment';

const { checkProperty } = Autoload.MainHelper;

class PropertyDataHandler {
  static getProperties = (properties) => {
    const newProperties = properties.map((tem) => {
      return {
        id: checkProperty(tem, 'id'),
        propertyName: checkProperty(tem, 'name'),
        propertyAddress: checkProperty(checkProperty(tem, 'propertyAdress'), 'streetno'),
        propertyCity: checkProperty(checkProperty(tem, 'propertyAdress'), 'city'),
        propertyZipCode: checkProperty(checkProperty(tem, 'propertyAdress'), 'zipCode'),
        propertyNoOfUnits: checkProperty(tem, 'numberOfRentalUnits'),
        propertyAreaOfUnits: checkProperty(tem, 'totalRentingSpace'),
        cutOffDate: `${checkProperty(checkProperty(tem, 'cutOffDate'), 'day', '31')} ${moment()
          .month(parseInt(checkProperty(checkProperty(tem, 'cutOffDate'), 'month', '12')) - 1)
          .format('MMMM')}`,
        heatingType: checkProperty(tem, 'heatingType'),
        heatingTemp: checkProperty(tem, 'heatingTemperature'),
        consumptionValue: checkProperty(tem, 'consumptionShare'),
        energyFuelType: checkProperty(tem, 'energyFuelType'),
        isWegModeActive: checkProperty(tem, 'isWegModeActive', false)
      };
    });
    return newProperties;
  };

  static getPropertiesData = (properties) => {
    const newProperties = properties.map((tem) => {
      return {
        id: Autoload.MainHelper.checkProperty(tem, 'id'),
        propertyName: Autoload.MainHelper.checkProperty(tem, 'name'),
        propertyAddress: Autoload.MainHelper.checkProperty(
          Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
          'streetno'
        ),
        propertyCity: Autoload.MainHelper.checkProperty(
          Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
          'city'
        ),
        propertyZipCode: Autoload.MainHelper.checkProperty(
          Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
          'zipCode'
        ),
        propertyNoOfUnits: Autoload.MainHelper.checkProperty(tem, 'numberOfRentalUnits'),
        propertyAreaOfUnits: Autoload.MainHelper.checkProperty(tem, 'totalRentingSpace'),
        cutOffDate: `${Autoload.MainHelper.checkProperty(
          Autoload.MainHelper.checkProperty(tem, 'cutOffDate'),
          'day',
          '31'
        )} ${moment()
          .month(
            parseInt(
              Autoload.MainHelper.checkProperty(Autoload.MainHelper.checkProperty(tem, 'cutOffDate'), 'month', '12')
            ) - 1
          )
          .format('MMMM')}`,
        heatingType: Autoload.MainHelper.checkProperty(tem, 'heatingType'),
        heatingTemp: Autoload.MainHelper.checkProperty(tem, 'heatingTemperature'),
        consumptionValue: Autoload.MainHelper.checkProperty(tem, 'consumptionShare'),
        energyFuelType: Autoload.MainHelper.checkProperty(tem, 'energyFuelType'),
        isWegModeActive: Autoload.MainHelper.checkProperty(tem, 'isWegModeActive', false)
      };
    });
    return newProperties;
  };

  static getProperty = (tem, propertySelected) => {
    return {
      ...tem,
      id: Autoload.MainHelper.checkProperty(tem, 'id'),
      propertyName: Autoload.MainHelper.checkProperty(tem, 'name'),
      name: Autoload.MainHelper.checkProperty(tem, 'name'),
      propertyAddress: Autoload.MainHelper.checkProperty(
        Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
        'streetno'
      ),
      propertyCity: Autoload.MainHelper.checkProperty(
        Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
        'city'
      ),
      propertyZipCode: Autoload.MainHelper.checkProperty(
        Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
        'zipCode'
      ),
      propertyNoOfUnits: Autoload.MainHelper.checkProperty(tem, 'numberOfRentalUnits'),
      propertyAreaOfUnits: Autoload.MainHelper.checkProperty(tem, 'totalRentingSpace'),
      cutOffDate: Autoload.MainHelper.checkProperty(tem, 'cutOffDate'),
      heatingType: Autoload.MainHelper.checkProperty(tem, 'heatingType'),
      heatingTemp: Autoload.MainHelper.checkProperty(tem, 'heatingTemperature'),
      heatingTemperature: Autoload.MainHelper.checkProperty(tem, 'heatingTemperature'),
      consumptionValue: Autoload.MainHelper.checkProperty(tem, 'consumptionShare', 0),
      consumptionShare: Autoload.MainHelper.checkProperty(tem, 'consumptionShare', 0),
      energyFuelType: Autoload.MainHelper.checkProperty(tem, 'energyFuelType'),
      propertyType: Autoload.MainHelper.checkProperty(tem, 'propertyType'),
      totalRentingSpace: Autoload.MainHelper.checkProperty(tem, 'totalRentingSpace'),
      numberOfRentalUnits: Autoload.MainHelper.checkProperty(tem, 'numberOfRentalUnits'),
      centralWarmWaterAllocationKey: Autoload.MainHelper.checkProperty(tem, 'centralWarmWaterAllocationKey'),
      isMeterReadingConducted: Autoload.MainHelper.checkProperty(tem, 'isMeterReadingConducted'),
      pictureLocation: Autoload.MainHelper.checkProperty(tem, 'pictureLocation'),
      receiptEmail: Autoload.MainHelper.checkProperty(tem, 'receiptEmail'),
      meterReadingsEmail: Autoload.MainHelper.checkProperty(tem, 'meterReadingsEmail'),
      accountId: Autoload.MainHelper.checkProperty(tem, 'accountId'),
      totalOccupantsCount: Autoload.MainHelper.checkProperty(tem, 'totalOccupantsCount'),
      occupantsConfiguration: Autoload.MainHelper.checkProperty(tem, 'occupantsConfiguration'),
      isConsumptionSectionHidden: Autoload.MainHelper.checkProperty(tem, 'isConsumptionSectionHidden'),
      isDocumentSectionHidden: Autoload.MainHelper.checkProperty(tem, 'isDocumentSectionHidden'),
      isMessageSectionHidden: Autoload.MainHelper.checkProperty(tem, 'isMessageSectionHidden'),
      isWegModeActive: Autoload.MainHelper.checkProperty(tem, 'isWegModeActive', false),
      wegCutOffDate: Autoload.MainHelper.checkProperty(tem, 'wegCutOffDate', null),
      //dummy data
      propertyOwner: tem?.propertyOwner,
      // (tem?.id === propertySelected?.id && propertySelected?.propertyOwner) ? 
      // propertySelected?.propertyOwner  
      // :
      // {
      //   name: '',
      //   street: '',
      //   postalCode: '',
      //   city: '',
      //   phoneNumber: '',
      //   email: '',
      //   taxNumber: ''
      // },
      isPropertyOwnerInfoEnabled: tem?.isPropertyOwnerInfoEnabled,
      isPropertyOwnerInfoInMessagesEnabled: tem?.isPropertyOwnerInfoInMessagesEnabled
    };
  }

  static getPropertiesDataNew = (properties, propertySelected) => {
    const newProperties = properties.map((tem) => this.getProperty(tem, propertySelected));
    return newProperties;
  };
}

export default PropertyDataHandler;
